import { IEvent } from '@src/interfaces';
import Classify from '@utils/Classify';
import React from 'react';
import { Form } from 'react-bootstrap';
import useValidation from '../../Hooks/useValidation';

interface Props {
  required?: boolean,
  name: string,
  title: string,
  value: string,
  setter: (value: string) => void,
  autoFocus?: boolean
}

const Password: React.FC<Props> = (props) => {

  const { isNotEmpty } = useValidation();

  const isValid = () => {
    return !props.required || (props.required && isNotEmpty(props.value));
  }

  return (
    <Form.Group controlId={props.name} className={'form-group ' + Classify.addClassName(!isValid(), 'has-error')}>
      <Form.Label>{props.title}</Form.Label>
      <Form.Control
        isInvalid={!isValid()}
        type="password"
        value={props.value}
        onChange={(e: IEvent) => {
          props.setter(e.currentTarget.value);
        }}
      // autoFocus={!!props.autoFocus}
      />
    </Form.Group>
  );
}

export default Password;